import React, { useState } from "react";
import { styled } from "styled-components";
import { Common } from "../../styles/Common";
import NormalUser from "../../assets/Signup/NormalUser.png";
import ExpertUser from "../../assets/Signup/ExpertUser";
import SignupCheckIcon from "../../assets/Signup/CheckIcon";
import { useNavigate } from "react-router-dom";

const UserTypeSelect = () => {
    const [membershipClassification, setMembershipClassification] = useState<true | false | null>(null);
    const navigate = useNavigate();

    const handleNext = () => {
        if (membershipClassification === true) {
            navigate("/signup");
        } else if (membershipClassification === false) {
            navigate("/signup/expert");
        }
    };

    return (
        <TypeSelect_Container>
            <TypeSelectHeader>회원가입</TypeSelectHeader>
            <div>
                <TitleContainer>
                    <Title>환영해요!</Title>
                    <SubTitle>미스고 이용을 위해 회원가입을 완료해주세요</SubTitle>
                </TitleContainer>

                <SelectBoxContainer>
                    <SelectBox isChecked={membershipClassification === true} onClick={() => setMembershipClassification(true)}>
                        <SelectBoxLeft>
                            <ImageContainer>
                                <img src={NormalUser} alt="Normal User" width={32} />
                            </ImageContainer>
                            <SelectBoxTitle>일반회원</SelectBoxTitle>
                        </SelectBoxLeft>
                        <SignupCheckIcon isChecked={membershipClassification === true} />
                    </SelectBox>
                    <SelectBox isChecked={membershipClassification === false} onClick={() => setMembershipClassification(false)}>
                        <SelectBoxLeft>
                            <ImageContainer>
                                <ExpertUser />
                            </ImageContainer>
                            <SelectBoxTitle>전문가 회원</SelectBoxTitle>
                        </SelectBoxLeft>
                        <SignupCheckIcon isChecked={membershipClassification === false} />
                    </SelectBox>
                </SelectBoxContainer>
            </div>
            <BottomSheet>
                <BottomSheetButton onClick={handleNext} disabled={membershipClassification === null}>
                    다음
                </BottomSheetButton>
            </BottomSheet>
        </TypeSelect_Container>
    );
};

export default UserTypeSelect;

const TypeSelect_Container = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 30%;
    cursor: pointer;
    position: relative;
    padding: 24px;

    .loginText {
        font-size: 14px;
        font-weight: 500;
        color: ${Common.colors.normalTextColor};
        margin-top: 20px;
    }

    @media screen and (max-width: 768px) {
        gap: 40px;
        height: 100%;
    }
`;

const TypeSelectHeader = styled.div`
    width: 100%;
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    line-height: 28px;
`;

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    gap: 4px;
    margin-top: 40px;
`;

const Title = styled.div`
    font-size: 24px;
    font-weight: 500;
    line-height: 40px;
`;

const SubTitle = styled.div`
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
`;

const SelectBoxContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 40px;
`;

const SelectBox = styled.div<{ isChecked?: boolean }>`
    display: flex;
    align-items: center;
    gap: 10px;
    border: 2px solid ${(props) => (props.isChecked ? Common.colors.aucMarkerColor : "#EAEBEE")};
    border-radius: 8px;
    padding: 0 14px;
    height: 76px;
    justify-content: space-between;
`;

const SelectBoxLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
`;

const SelectBoxTitle = styled.div`
    font-size: 16px;
    font-weight: 400;
    line-height: 16px;
`;

const ImageContainer = styled.div`
    width: 48px;
    height: 48px;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    background-color: ${Common.colors.blue01};
`;

const BottomSheet = styled.div`
    bottom: 0;
    border: none;
    position: fixed;
    left: 0;
    right: 0;
    padding: 24px;
`;

const BottomSheetButton = styled.button`
    bottom: 15px;
    width: 100%;
    padding: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${Common.colors.aucMarkerColor};
    color: white;
    border-radius: 14px;
    font-size: 16px;
`;
